import React, { Component } from 'react'
import { Field, Progress, Button } from '../../elements'
import './passwordInput.css'
const PW_LENGTH_REQUIREMENT = 12

class PasswordInput extends Component {
  constructor(props) {
    super(props)
    this.state = {
      password: '',
      showBar: props.showBar,
      passwordStrengthScore: 20,
      passwordStrengthVis: 'red',
      passwordStrength: 0,
      passwordIcon: 'fal fa-eye',
      passwordFieldType: 'password',
      passwordRequirements: {
        length: false,
        uppercase: false,
        lowercase: false,
        number: false,
        symbol: false,
      },
    }
  }

  checkPassword = (password) => {
    this.setState({
      password,
      showBar: true,
    })

    // Initialize counter to zero
    let counter = 0

    // On each test that is passed, increment the counter
    // alert(password)
    if (password.length >= PW_LENGTH_REQUIREMENT) {
      // If string contain at least one lowercase alphabet character
      this.setState((state) => {
        state.passwordRequirements['length'] = true
        return state
      })
      counter++
    } else {
      this.setState((state) => {
        state.passwordRequirements['length'] = false
        return state
      })
    }

    if (/[a-z]/.test(password)) {
      // If string contain at least one lowercase alphabet character
      this.setState((state) => {
        state.passwordRequirements['lowercase'] = true
        return state
      })
      counter++
    } else {
      this.setState((state) => {
        state.passwordRequirements['lowercase'] = false
        return state
      })
    }
    if (/[A-Z]/.test(password)) {
      this.setState((state) => {
        state.passwordRequirements['uppercase'] = true
        return state
      })
      counter++
    } else {
      this.setState((state) => {
        state.passwordRequirements['uppercase'] = false
        return state
      })
      counter++
    }

    if (/[0-9]/.test(password)) {
      this.setState((state) => {
        state.passwordRequirements['number'] = true
        return state
      })
      counter++
    } else {
      this.setState((state) => {
        state.passwordRequirements['number'] = false
        return state
      })
    }

    if (/[!@#.$&*\s]/.test(password)) {
      this.setState((state) => {
        state.passwordRequirements['symbol'] = true
        return state
      })
      counter++
    } else {
      this.setState((state) => {
        state.passwordRequirements['symbol'] = false
        return state
      })
    }

    const passwordScore = counter
    let vis = 'danger'
    let scorePercent = 20

    switch (passwordScore) {
      case 0:
        vis = 'danger'
        scorePercent = 20
        break
      case 1:
        vis = 'danger'
        scorePercent = 20
        break
      case 2:
        // code block
        vis = 'danger'
        scorePercent = 40
        break
      case 3:
        vis = 'warning'
        scorePercent = 60
        // code block
        break
      case 4:
        vis = 'success'
        scorePercent = 80
        // code block
        break
      case 5:
        vis = 'success'
        scorePercent = 100
        // code block
        break
      default:
        vis = 'danger'
        scorePercent = 20
    }

    this.setState({
      passwordStrengthVis: vis,
      passwordStrengthScore: scorePercent,
      passwordStrength: passwordScore,
    })

    // Check if at least three rules are satisfied
    //return counter >= 3;

    this.props.onChange(counter, password)
    setTimeout(
      function() {
        this.setState({
          showBar: false,
        })
      }.bind(this),
      4500
    )
  }

  toggleShowPassword = () => {
    if (this.state.passwordIcon === 'fal fa-eye') {
      this.setState({
        passwordIcon: 'fal fa-eye-slash',
        passwordFieldType: 'text',
      })
    } else {
      this.setState({
        passwordIcon: 'fal fa-eye',
        passwordFieldType: 'password',
      })
    }
  }

  render() {
    const {
      passwordStrengthScore,
      passwordStrengthVis,
      password,
      passwordIcon,
      passwordFieldType,
    } = this.state

    return (
      <div>
        <div className="password-input">
          <Field
            name="password"
            id="password"
            wrapClassName={'mb-0'}
            iconLeft={'fal fa-lock'}
            placeholder={this.props.placeholder}
            fullwidth="true"
            showErrors={false}
            size={this.props.size}
            style={{ postion: 'relative' }}
            error={this.props.error}
            onChange={({ e, value }) => this.checkPassword(value)}
            value={password}
            hasAddOns={true}
            rightAddOn={
              <Button
                type="button"
                className={`is-${this.props.size} pl-2 pr-2`}
                onClick={() => this.toggleShowPassword()}
              >
                <i className={passwordIcon}></i>
              </Button>
            }
            type={'input'}
            textInputType={passwordFieldType}
          />
          {this.state.showBar && password !== '' && (
            <Progress
              className={'password-progress'}
              defaultValue={passwordStrengthScore}
              color={passwordStrengthVis}
              size="small"
              max={100}
            />
          )}
        </div>
        {this.props.showHints && password !== '' && (
          <div className="password-tips is-size-7">
            {this.state.passwordRequirements.lowercase && (
              <div className="has-text-success">
                <i className="fas fa-check"></i> Contains lowercase letters
              </div>
            )}
            {!this.state.passwordRequirements.lowercase && (
              <div className="has-text-danger">
                <i className="fas fa-times"></i> Contains lowercase letters
              </div>
            )}

            {this.state.passwordRequirements.uppercase && (
              <div className="has-text-success">
                <i className="fas fa-check"></i> Contains uppercase letters
              </div>
            )}
            {!this.state.passwordRequirements.uppercase && (
              <div className="has-text-danger">
                <i className="fas fa-times"></i> Contains uppercase letters
              </div>
            )}

            {this.state.passwordRequirements.length && (
              <div className="has-text-success">
                <i className="fas fa-check"></i> At least{' '}
                {PW_LENGTH_REQUIREMENT} characters
              </div>
            )}
            {!this.state.passwordRequirements.length && (
              <div className="has-text-danger">
                <i className="fas fa-times"></i> At least{' '}
                {PW_LENGTH_REQUIREMENT} characters
              </div>
            )}

            {this.state.passwordRequirements.symbol && (
              <div className="has-text-success">
                <i className="fas fa-check"></i> Contains a symbol
              </div>
            )}
            {!this.state.passwordRequirements.symbol && (
              <div className="has-text-danger">
                <i className="fas fa-times"></i> Contains a symbol
              </div>
            )}

            {this.state.passwordRequirements.number && (
              <div className="has-text-success">
                <i className="fas fa-check"></i> Contains a number
              </div>
            )}
            {!this.state.passwordRequirements.number && (
              <div className="has-text-danger">
                <i className="fas fa-times"></i> Contains a number
              </div>
            )}
          </div>
        )}
      </div>
    )
  }
}
export default PasswordInput

PasswordInput.defaultProps = {
  error: false,
  onChange: false,
  placeholder: 'Password',
  showHints: true,
  showBar: false,
  size: 'normal',
}
